<template>
  <div class="login-pwd" :style="{
    backgroundImage: 'url(' + backgroundImage + ')',
    '--theme-color': malltype == 'pdxfgq' ? '#299afb' : ''
  }">
    <div class="login-box">
      <router-link :to="this.$store.state.webCount.visitor_status == 0 ? '' : '/'">
        <img
          :src="this.$store.state.webCount.logo_wap"
          onerror="src='/static/images/login_logo.png'"
          class="logo"
        />
      </router-link>
    </div>
    <div class="login-cont">
      <div class="van-cell">
        <img src="./../../assets/img/login-zh.svg" alt="" />
        <div class="van-cell__value">
          <input
            type="text"
            :placeholder="placeholderText ? '请输入八位员工号' : '请输入账号'"
            v-model="account"
            class="van-field__control"
          />
        </div>
      </div>
      <div v-if="pwdType == false" class="van-cell">
        <img src="./../../assets/img/login-pwd.svg" alt="" />
        <div class="van-cell__value">
          <input
            type="password"
            placeholder="请输入密码"
            v-model="password"
            class="van-field__control"
          />
        </div>
        <i @click="changeType()" class="van-icon iconfont icon-yanjing-bi inputlabel"></i>
      </div>
      <div v-if="pwdType == true" class="van-cell">
        <img src="./../../assets/img/login-pwd.svg" alt="" />
        <div class="van-cell__value">
          <input
            type="text"
            placeholder="请输入密码"
            v-model="password"
            class="van-field__control"
          />
        </div>
        <i @click="changeType()" class="van-icon iconfont icon-ai-eye inputlabel"></i>
      </div>

      <div v-if="codeshow" class="van-cell" style="padding-top: 0.3rem; padding-bottom: 0.3rem">
        <img src="./../../assets/img/login-code.svg" alt="" />
        <div class="van-cell__value">
          <input type="text" placeholder="请输入验证码" v-model="code" class="van-field__control" />
        </div>
        <div class="van-field__button">
          <div class="code" @click="refreshCode">
            <s-identify :identifyCode="identifyCode"></s-identify>
          </div>
        </div>
      </div>

      <van-button class="loginbtn" @click="senData()" :loading="loading"> 登&#8194;录 </van-button>

      <div class="login-text">
        <router-link to="/backpass">
          <div class="forgot-password">忘记密码？</div>
        </router-link>
        <router-link v-if="this.$store.state.webCount.register_status == 1" to="/register">
          <div class="restBox">立即注册</div>
        </router-link>
      </div>
    </div>

    <div class="other-way" :style="{'justify-content': !isShowWeixin ? 'center' : 'space-between'}">
      <div class="login_wx" v-if="isShowWeixin">
        <img class="wx" @click="wxlogin" src="./../../assets/img/login-wx.svg" alt />
        <span>微信登录</span>
      </div>
      <router-link to="/login" tag="div" class="text-cent">
        <div class="login_wx">
          <img src="./../../assets/img/login-iphone.svg" alt />
          <span>手机短信登录</span>
        </div>
      </router-link>
    </div>
    <Nvc 
      ref="nverify" 
      :verify="verifyMethods"
    ></Nvc>
  </div>
</template>

<script>
import SIdentify from "../../components/identify";
import Nvc from "./components/nvc";
import md5 from "js-md5";
export default {
  name: "index",
  components: {
    SIdentify,
    Nvc
  },
  data() {
    return {
      loading: false,
      datas: "",
      account: "",
      password: "",
      step: 0,
      codeshow: false,
      code: "",
      identifyCodes: "1234567890", //图片验证码
      identifyCode: "", //图片验证码
      pwdType: false, //此时文本框隐藏，显示密码框
      root: process.env.API_ROOT,
      malltype: "",
      backgroundImage: require("./../../assets/img/login-bg.png"),
      includeMalltype: ["lipinduihuan", "xfj", 'tkl', 'srys'],
      includeMalltype1: ['kmzhfl'],
      includeMallWexin: ['hnyhxj', 'yongrongshop'],
      placeholderText: false
    };
  },
  computed: {
    isShowWeixin() {
      var str = window.location.host;
      var malltype = str.split(".")[0];
      return !this.includeMallWexin.includes(malltype);
    }
  },
  watch: {
    password: function(newVal, oldVal) {
      this.password = this.password.replace(/\s+/g, "");
    }
  },
  methods: {
    goEegister: function() {
      this.$router.push({ name: "Register" });
    },
    //密码的显示隐藏
    changeType: function() {
      this.pwdType = !this.pwdType; //跟着小眼睛变化，密码框隐藏显示文本框，内容就显示了
    },
    getCode: function() {
      this.$api.post("WebApi/Login/Index/getcode", null, res => {
        this.codeimg = res.data.data.codeimg;
      });
    },
    senData: function() {
      // 进行人机验证
      if (this.account == "") {
        this.$toast("账号不能为空");
        return false;
      }
      if (this.password == "") {
        this.$toast("密码不能为空");
        return false;
      }
      const reg = new RegExp(/[^\x00-\xff]+$/)
      if (reg.test(this.password)) {
        this.$toast("不能使用汉字或全角字符作为密码");
        return 
      }
      this.$refs.nverify.startVerify()
    },
    getDatas: function () {
      var isUser = localStorage.getItem('BLHuser')
      var mallid = localStorage.getItem('mallid')
      return new Promise((resolve, reject) => {
        this.$api.post('/user/user/info', { id_example: mallid, token_user: isUser }, res => {
          if (res.data.code == '100') {
            localStorage.setItem('isResetting', res.data.data.is_reset_password)
            resolve(1)
          }
        })
      });
      
    },
    comit: function(nvc) {
      return new Promise((resolve, reject) => {
        var mallid = localStorage.getItem("mallid");
        this.loading = true;
        this.$api.post(
          "user/login/login",
          {
            id_example: mallid,
            type: 1,
            account: this.account,
            password: this.password,
            captchaVerifyParam: nvc
          },
          async res => {
            if (res.data.code == "100") {
              localStorage.setItem("BLHuser", res.data.data.token_user);
              resolve(true)
              await this.getDatas()
              var url = localStorage.getItem("routerUrl");
              this.$store.commit("userInfo");
              if (url != undefined && url != null && url != "") {
                this.$router.push({ name: url, params: { isAuth: true } }); //跳到路由拦截前的地址
              } else {
                this.$router.push({ name: "Home", params: { isAuth: true } });
              }
            } else if (
              res.data.code == "200" ||
              res.data.code == "400" ||
              res.data.code == "600" ||
              res.data.code == "900"
            ) {
              resolve(false)
            } else if (res.data.code == "800") {
              this.$toast("登录次数过多请稍后再试");
              resolve(true)
            } else {
              this.$toast(res.data.message);
              this.step++;
              this.identifyCode = "";
              this.makeCode(this.identifyCodes, 4);
              if (this.step == 3) {
                this.codeshow = true;
              }
              resolve(true)
            }
            this.loading = false;
          }
        );
      })
      
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    wxlogin: function() {
      var mallid = localStorage.getItem("mallid");
      var root = process.env.LOGIN_URL;
      var backurl = window.location.origin + "/wxlogin";
      backurl = encodeURIComponent(backurl);
      window.location.href =
        root + "?reurl=" + backurl + "&id_example=" + mallid;
    },
    verifyMethods(captchaVerifyParam) {
      return new Promise(async(resolve, reject) => {
        const data = await this.comit(captchaVerifyParam)
        resolve(data)
      })
    }
  },
  mounted() {
    var str = window.location.host;
    this.malltype = str.split(".")[0];

    if (this.includeMalltype.includes(this.malltype)) {
      this.$router.replace({
        path: "/login"
      });
    }

    if (this.malltype == "pdxfgq") {
      this.backgroundImage = require("./../../assets/img/login-bg-xf.png");
    }

    if(this.malltype == "kmzhfl" || this.malltype == "geren") {
      this.placeholderText = true
    }
  },
};
</script>

<style lang="less">
.login-pwd {
  --theme-color: linear-gradient(111deg, #e23130 0%, #e23130 100%);

  width: 100%;
  min-height: 100vh;
  background-image: url("./../../assets/img/login-bg.png");
  background-size: 100% 100%;
  background-position-y: -1rem;
  background-repeat: no-repeat;

  .login-box {
    text-align: center;
    padding-top: 0.6rem;

    .logo {
      width: auto;
      min-width: 1.84rem;
      max-width: 1.84rem;
    }
  }

  .login-cont {
    margin-top: 0.84rem;
    box-sizing: border-box;
    padding: 0 0.6rem;

    .van-cell {
      padding: 0.46rem 0;
      border-bottom: 0.01rem solid rgba(26, 26, 26, 0.08);
      background: transparent !important;
      display: flex;
      align-items: center;

      &::after {
        border: none;
      }

      img {
        width: 0.48rem;
        height: 0.48rem;
      }

      .van-cell__value {
        padding-left: 0.2rem;
        .van-field__control {
          &::placeholder {
            color: rgba(38, 38, 38, 0.5);
          }
        }
      }
      .inputlabel {
        color: rgba(80, 80, 80, 0.6rem);
        font-size: 0.4rem;
      }

      .van-field__button {
        .code {
          width: 1.68rem;
          height: 0.88rem;

          .s-canvas {
            width: 100%;
            height: 100%;
            #s-canvas {
              width: 1.68rem;
              height: 0.88rem;
            }
          }
        }
      }
    }

    .loginbtn {
      width: 100%;
      height: 0.96rem;
      background: var(--theme-color);
      border-radius: 0.48rem;
      font-size: 0.3rem;
      font-weight: 500;
      color: #ffffff;
      line-height: 0.42rem;
      margin-top: 1rem;
      border: none;
    }

    .login-text {
      margin-top: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .forgot-password {
        font-size: 0.28rem;
        font-weight: 400;
        color: rgba(38, 38, 38, 0.5);
        line-height: 0.48rem;
      }

      .restBox {
        width: 1.12rem;
        height: 0.4rem;
        font-size: 0.28rem;
        font-weight: 500;
        color: #025bff;
        line-height: 0.48rem;
      }
    }
  }

  .other-way {
    box-sizing: border-box;
    padding: 1rem 2rem 0 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .login_wx {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 0.88rem;
        height: 0.88rem;
      }

      span {
        margin-top: 0.2rem;
        font-size: 0.24rem;
        font-weight: 400;
        color: #929292;
        line-height: 0.42rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue